var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Features',_vm._b({key:_vm.key,on:{"show-wizard":_vm.showWizard}},'Features',_vm.featuresProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }